import { createAction, props } from '@ngrx/store';

const GET_TABLE_ACL = '[TableAcl] Get TableAcl';
const SAVE_TABLEACL = '[TableAcl] Save TableAcl';
const SET_TABLEACL = '[TableAcl] Set TableAcl';
const DELETE_TABLEACL = '[TableAcl] Delete TableAcl';
const UPDATE_TABLEACL = '[TableAcl] Update TableAcl';
const NEW_ACL_CREATED = '[TableAcl] Newly Created TableAcl';
const DELETE_ACL_RECORD = '[TableAcl] Deleted Acl Record';
const UPDATE_ACL_RECORDS = '[TableAcl] Update Acl Records';
const GET_UPDATED_ACL_RECORDS = '[TableAcl] Get Updated Acl Records';
const ERROR_MESSAGE = '[TableAcl] Get Error Messages';
const SET_RECORDS_NULL = '[TableAcl] set Null records';
const SAVE_BATCH_TABLEACL = '[TableAcl] Create TableAcl Batch';
const NEW_BATCH_TABLEACL = '[TableAcl] Create TableAcl Batch';

const getTableAcl = createAction(GET_TABLE_ACL, props<{ apiConstants: any; tableid: any }>());

const setTableAcl = createAction(SET_TABLEACL, props<{ aclTable: any }>());

const updateTableAclRecords = createAction(UPDATE_TABLEACL, props<{ tableAclRecords: [] }>());

const saveTableAcl = createAction(SAVE_TABLEACL, props<{ saveapiConstants: any; aclData: any }>());

const deleteTableAcl = createAction(DELETE_TABLEACL, props<{ apiConstants: any; ids: any }>());

const newAclCreated = createAction(NEW_ACL_CREATED, props<{ createdAcl: any }>());

const deletedAcl = createAction(DELETE_ACL_RECORD, props<{ deletedSid: any }>());

const updateAclBatch = createAction(UPDATE_ACL_RECORDS, props<{ apiConstants: any; actionIds: any }>());

const newUpdatedAclRecords = createAction(GET_UPDATED_ACL_RECORDS, props<{ updatedRecords: any }>());

const setUpdatedRecordsNull = createAction(SET_RECORDS_NULL, props<{ updatedRecords: any }>());

const getErrorMessage = createAction(ERROR_MESSAGE, props<{ errorMessage: any }>());

const saveBatchTableAcl = createAction(SAVE_BATCH_TABLEACL, props<{ saveapiConstants: any; aclData: any }>());

const newlyCreatedAclBatch = createAction(NEW_BATCH_TABLEACL, props<{ newlyCreatedaclDataBatch: any }>());

export {
  getTableAcl,
  setTableAcl,
  saveTableAcl,
  deleteTableAcl,
  updateTableAclRecords,
  newAclCreated,
  deletedAcl,
  updateAclBatch,
  newUpdatedAclRecords,
  getErrorMessage,
  setUpdatedRecordsNull,
  saveBatchTableAcl,
  newlyCreatedAclBatch
};
